import { useMutation, useQuery } from 'react-query';
import { useProgramDao } from 'shared/dao/programDao';
import {
  IProgramRequestPayload,
  IProgramResponsePayload,
  ITvProgramListCreatePayload,
  ITvProgramListUpdatePayload,
} from 'shared/interfaces/IProgram';

export const useProgramService = () => {
  const {
    getProgram: getProgramDao,
    getProgramSearch: getProgramSearchDao,
    getSingleTvProgramList: getSingleTvProgramListDao,
    createTvProgramList: createTvProgramListDao,
    updateTvProgramList: updateTvProgramListDao,
    deleteTvProgramList: deleteTvProgramListDao,
  } = useProgramDao();

  const getProgram = (payload?: IProgramRequestPayload) => {
    const { isLoading, isError, error, data, isFetching, isPreviousData } = useQuery<IProgramResponsePayload, Error>(
      ['program', payload],
      () => getProgramDao(payload),
    );

    return {
      data,
      error,
      isLoading,
      isError,
      isFetching,
      isPreviousData,
    };
  };

  // FOR FILTER SEARCH

  const getProgramSearch = (payload?: IProgramRequestPayload) => {
    const { isLoading, isError, error, data, isFetching, isPreviousData } = useQuery<IProgramResponsePayload, Error>(
      ['program-filter-search', payload],
      () => getProgramSearchDao(payload),
    );

    return {
      data,
      error,
      isLoading,
      isError,
      isFetching,
      isPreviousData,
    };
  };

  // Get single
  const getSingleTvProgramList = (id?: string) => {
    const { isLoading, isError, error, data, isFetching, isPreviousData } = useQuery<IProgramResponsePayload, Error>(
      ['single-program', id],
      () => getSingleTvProgramListDao(id || ''),
      { enabled: !!id },
    );

    return {
      data: data?.data,
      // data: data,
      error,
      isLoading,
      isError,
      isFetching,
      isPreviousData,
    };
  };

  const createTvProgramList = () => {
    const createMutation = useMutation((payload?: { data?: ITvProgramListCreatePayload }) =>
      createTvProgramListDao(payload),
    );

    return {
      createMutation,
    };
  };

  const updateTvProgramList = () => {
    const updateMutation = useMutation((payload: { data?: ITvProgramListUpdatePayload }) =>
      updateTvProgramListDao(payload),
    );

    return {
      updateMutation,
    };
  };

  const deleteTvProgramList = () => {
    const deleteMutation = useMutation((id: string) => deleteTvProgramListDao(id));

    return {
      deleteMutation,
    };
  };

  return {
    getProgram,
    getProgramSearch,
    //
    getSingleTvProgramList,
    createTvProgramList,
    updateTvProgramList,
    deleteTvProgramList,
  };
};
